const SuccessPageStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(135deg, #81c241, #6aa832)',
    textAlign: 'center',
    position: 'relative',
    color: '#fff',
    padding: '0 1rem',
    overflow: 'hidden',
  },
  content: {
    zIndex: 10,
    animation: 'fadeIn 1s ease-out',
  },
  successMessage: {
    fontSize: '4rem',
    fontWeight: '700',
  },
  subMessage: {
    fontSize: '1.5rem',
    fontWeight: '400',
    marginBottom: '1.5rem',
  },
  button: {
    padding: '12px 24px',
    fontSize: '1rem',
    fontWeight: 'bold',
    backgroundColor: '#81c241',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#6aa832',
      transform: 'scale(1.05)',
    },
  },
};

export default SuccessPageStyles;
